import React from "react";
import { CardSubtitle } from "@progress/kendo-react-layout";
import { Tooltip } from "@progress/kendo-react-tooltip";
import CustomToolTip from "./CustomToolTip";
import CustomEOIToolTip from "./CustomEOIToolTip";
import { currencyFormat } from "../../services/shareconstant";
import { SvgIcon } from "@progress/kendo-react-common";
import { infoCircleIcon } from "@progress/kendo-svg-icons";

export default function CoverageCard(props) {
  return (
    <>
    
      <div className="wrapper-Block">
        <div className="planDetailsBlock">
          {props.card.currentDetails.summaryAttributes &&
            Object.keys(props.card.currentDetails.summaryAttributes).map(
              (key, i) => (
                <div key={i}>
                  {(props.card.status==='EOI Pending') && key==='EOI Amount' ?
                   <CardSubtitle className="label-viewdetails">
                   {" "}
                   {key}
                 </CardSubtitle>                
                  :((key!=='EOI Amount')? 
                  <CardSubtitle className="label-viewdetails">
                   {" "}
                   {key}
                 </CardSubtitle>  
                 :null)             
                }
                
                 {(props.card.status==='EOI Pending') && key==='EOI Amount' ?
                      currencyFormat(
                        parseInt(
                          props.card.currentDetails.summaryAttributes[key]
                        )
                      )               
                  :((key!=='EOI Amount')? 
                  <span>
                   {" "}                    
                   {isNaN(props.card.currentDetails.summaryAttributes[key])
                     ? props.card.currentDetails.summaryAttributes[key]
                     : currencyFormat(
                         parseInt(
                           props.card.currentDetails.summaryAttributes[key]
                         )
                       )}
                 </span>
                 :null)
                 }
                 
                </div>
              )
            )}
        </div>
        <div className="memberCostBlock">
          {props.card.discountOrPremiumWaiverEligible === true
            ? props.card.currentDetails &&
              Object.keys(props.card.currentDetails).map(
                (key, i) =>
                  key !== "discountOrPremiumWaiverAttributes" &&
                  key !== "summaryAttributes" && (
                    <div key={i}>
                      {key === "memberCost" ? (
                        <>
                          <Tooltip
                            content={(prop) => (
                              <CustomToolTip
                                key={i}
                                data={
                                  props.card?.currentDetails
                                    ?.discountOrPremiumWaiverAttributes
                                }
                              />
                            )}
                            anchorElement="target"
                            position="bottom"
                          >
                            <span className="label-viewdetails">
                              Member Monthly Cost{" "}
                            </span>
                            <SvgIcon icon={infoCircleIcon} title="Member Monthly Cost"></SvgIcon>
                          </Tooltip>
                        </>
                      ) : (
                        <div>
                          {" "}
                          {key === "fullCost" && (props.card.status==='EOI Pending') ? <>
                          <Tooltip
                            content={(prop) => (
                              <CustomEOIToolTip                               
                              />
                            )}
                            anchorElement="target"
                            position="bottom"
                          >
                            <span className="label-viewdetails">
                            Full Monthly Cost{" "}
                            </span>
                            <SvgIcon icon={infoCircleIcon} title="Full Monthly Cost"></SvgIcon> 
                          </Tooltip>
                        </> : (key === "fullCost"?<CardSubtitle className="label-viewdetails">Full Monthly Cost</CardSubtitle>:key)}
                        </div>
                      )}
                      <span>
                        {" "}
                        {isNaN(props.card.currentDetails[key])
                          ? props.card.currentDetails[key]
                          : props.card.currentDetails[key] === -1 ? 'TBD' : currencyFormat(props.card.currentDetails[key])}{" "}
                      </span>
                    </div>
                  )
              )
            : props.card.currentDetails &&
              Object.keys(props.card.currentDetails).map(
                (key, i) =>
                  key !== "discountOrPremiumWaiverAttributes" &&
                  key !== "summaryAttributes" &&
                  key !== "fullCost" && (
                    <div key={i}>
                      <CardSubtitle className="label-viewdetails">
                        {" "}
                        {key === "memberCost" ? "Member Monthly Cost" : key}{" "}
                      </CardSubtitle>
                      <span>
                        {" "}
                        {isNaN(props.card.currentDetails[key])
                          ? props.card.currentDetails[key]
                          : props.card.currentDetails[key] === -1 ? 'TBD' : currencyFormat(props.card.currentDetails[key])}{" "}
                      </span>
                    </div>
                  )
              )}
        </div>
      </div>
    </>
  );
}
